import { render, staticRenderFns } from "./BoxType.vue?vue&type=template&id=53231da7&"
import script from "./BoxType.vue?vue&type=script&lang=js&"
export * from "./BoxType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports